import React from 'react';
import type { ElementRef } from 'react';

import { styled } from '@backyard-ui/styles';

import styles from './Spinner.styles';

export interface SpinnerProps {
  /**
   * The spinner color.
   */
  color?:
    | 'critical'
    | 'info'
    | 'primary'
    | 'secondary'
    | 'warning'
    | 'black'
    | 'white';

  /**
   * Define the spinner size.
   */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const SpinnerEl = styled('svg', styles);

const Spinner = React.forwardRef<ElementRef<'svg'>, SpinnerProps>(
  (props, ref) => {
    return (
      <SpinnerEl viewBox="0 0 50 50" role="presentation" ref={ref} {...props}>
        <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
      </SpinnerEl>
    );
  }
);

Spinner.displayName = 'Spinner';

export default Spinner;
